import { Box } from '@mui/material';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { RenderTable } from '../../../../components/ui';

interface IProps {
  compartmentData: any;
  handleCompartmentData: any;
  handlePartAddModal: any;
  isView: boolean;
}

const TController = ({
  compartmentData,
  isView,
  handleCompartmentData,
  handlePartAddModal,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            compartmentData,
            isView,
          }}
        />
        <TBody
          {...{
            compartmentData,
            isView,
            handleCompartmentData,
            handlePartAddModal,
          }}
        />
        <TFoot
          preparedBy={compartmentData.report_prepared_by}
          approvedBy={compartmentData.report_approved_by}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
